export const configApi = {
  property: 'config/r/:country/v1/property/:objectID',
};
